import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GroupType, ProcessedValuePredictorAnswer, UnprocessedValuePredictorAnswer } from '@fgb/core';

@Component({
  selector: 'fgbcl-answer-type-counter',
  templateUrl: './answer-type-counter.component.html',
  styleUrl: './answer-type-counter.component.scss',
})
export class AnswerTypeCounterComponent {
  @Input() answers: UnprocessedValuePredictorAnswer[] | ProcessedValuePredictorAnswer[] = [];
  @Input() groupType: GroupType;
  @Output() answerSelected = new EventEmitter<any>();
  groupTypes = GroupType;
  @Input() isExternal: boolean = false;
  onAnswerSelected(answerId: number, answer: any) {
    // if(this.groupType == GroupType.Trivia){
    //   this.submitTriviaAnswer(answer);
    // }

    if (this.groupType == GroupType.Predictor) {
      this.answerSelected.emit({ answerId: answerId, customerValue: answer });
    }
  }
}
